var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiurim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/video-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/video-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9974 20.3334C16.5998 20.3334 20.3307 16.6025 20.3307 12.0001C20.3307 7.39771 16.5998 3.66675 11.9974 3.66675C7.39502 3.66675 3.66406 7.39771 3.66406 12.0001C3.66406 16.6025 7.39502 20.3334 11.9974 20.3334Z",
    fill: "#0082CD",
    stroke: "#0082CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.58594 12V10.7667C9.58594 9.17499 10.7109 8.53333 12.0859 9.32499L13.1526 9.94166L14.2193 10.5583C15.5943 11.35 15.5943 12.65 14.2193 13.4417L13.1526 14.0583L12.0859 14.675C10.7109 15.4667 9.58594 14.8167 9.58594 13.2333V12Z",
    stroke: "#0082CD",
    fill: "#FFFFFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiurim);
export default __webpack_public_path__ + "static/media/shiurim.bae3f1d60972bf73bbc8b1d0bcb6b506.svg";
export { ForwardRef as ReactComponent };